import request from '@/utils/request.js'
import { handlerGetUrlParams } from '@/utils/dealUrlParams'
// 获取金融产品与服务
export function getIpProject(data) {
  return request({
    url: '/bus/financial/publishlist',
    method: 'GET',
    data
  })
}

// 查看详细信息
export function checkIpProject(id) {
  return request({
    url: `/bus/financial/${id}`,
    method: 'GET'
  })
}

// 获取新兴产业专利动态
export function getIndustryInfo(param) {
  return request({
    url: `/outer/monitor/theme/list/data?office_id=${param.id}&pageNumber=${param.pageNum}&sort_id=true&pageSize=${param.pageSize}`,
    method: 'GET'
  })
}

// 获取某一产业的列表专利动态
export function getIndustryList(params) {
  const url = handlerGetUrlParams('/outer/monitor/list/data', params)
  return request({
    url,
    method: 'GET'
  })
}

// 根据某一id获取专利详情动态
export function getIndustryDetailInfo(id) {
  return request({
    url: `/outer/monitor/view/data/${id}`,
    method: 'GET'
  })
}
